import { useState } from 'react';
import { ListItem } from './AppList'

type Props = {
    app: ListItem;
    openIndex: number | null;
    toggleAccordion: (index: number) => void;
    index: number;
}

const AppItemList = ({ app, toggleAccordion, openIndex, index }: Props) => {
    return (
        <div className="border border-gray-200 rounded-md">
            <button
                className="w-full flex justify-between items-center p-4 text-left"
                onClick={() => toggleAccordion(index)}
            >
                <span className="font-medium">{app.name}</span>
                <span
                    className={`transform transition-transform ${openIndex === index ? "rotate-180" : ""}`}
                >
                    ▼
                </span>
            </button>
            <div
                className={`overflow-hidden transition-all duration-300 ${openIndex === index ? "max-h-64" : "max-h-0"}`}
            >
                <div className="p-4 text-gray-700 border-t border-gray-200">
                    <div className='flex flex-col justify-center text-center gap-2'>
                        <div className="">
                            <p className='font-medium text-center'>Dev Urls:</p>
                            <hr />
                        </div>
                        {app?.urlPre?.length > 0 && app?.urlPre?.map((url, index) => (
                            <a key={index} href={url} target="_blank" rel="noreferrer" className="text-blue-500">
                                {url}
                            </a>
                        ))}
                        {app?.urlPre?.length === 0 && (
                            <p className='text-red-500'>No hay urls disponibles</p>
                        )}
                    </div>

                    <div className='flex flex-col justify-center text-center gap-2 mt-8'>
                        <div className="">
                            <p className='font-medium text-center'>Prod Urls:</p>
                            <hr />
                        </div>
                        {app?.urlProd?.length > 0 && app?.urlProd?.map((url, index) => (
                            <a key={index} href={url} target="_blank" rel="noreferrer" className="text-blue-500">
                                {url}
                            </a>
                        ))}
                        {app?.urlProd?.length === 0 && (
                            <p className='text-red-500'>No hay urls disponibles</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AppItemList